<template>
    <page>
        <div class="shadow-25 col-4">
            <v-header :title="'4005 - ' + $T('role not found')" icon="error"/>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <div class="q-pa-xl text-center">
                    {{ $T('user role not found in IMDL response.') }}
                </div>
            </card>
        </div>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NoUserRoleIMDL',
        methods: {
            async autoLogoff () {
                await this.$store.dispatch('auth/logout')
            }
        },
        created () {
            this.autoLogoff()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/4005.vue